import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

interface AcceleratorEarnedUntilProps {
  item: {
    earnedAccelOn: string | null;
  };
  isCABReport: boolean;
}

export const AcceleratorEarnedUntil: React.FC<AcceleratorEarnedUntilProps> = ({
  item = {},
  isCABReport = false,
}) => {
  const lastMonthEarned = get(item, 'earnedAccelOn', null);

  const {tt} = useTranslation('report.record.acceleratorEarnedUntil');
  const formattedDate = getDateUtilDefaultInstance().formatDate(
    lastMonthEarned,
    'MMMM d, yyyy',
  );

  const formattedDateForCABReport = getDateUtilDefaultInstance().formatDate(
    lastMonthEarned,
    'MMMM yyyy',
  );
  const reportDate = isCABReport ? formattedDateForCABReport : formattedDate;

  return (
    <>
      {tt('acceleratorEarnedUntil', () => (
        <Text
          variant="body"
          emphasis="medium"
          testID={Reports.reportLastEarned}>
          Last earned {reportDate}
        </Text>
      ))}
    </>
  );
};
